'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && require('call-bind/callBound')('Object.prototype.toString');

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/IsArray.js
 ** module id = 312
 ** module chunks = 0
 **/